import React, { useState } from "react";
import { Pagination } from "antd";
import CircularProgress from "../../components/CircularProgress";
import { useAuth0 } from "@auth0/auth0-react";
import { usePageQueries } from "./queries";
import _ from "lodash";

import NewsCard from "../../components/Widgets/NewsCard/NewsCard.js";

const News = () => {
  const { isAuthenticated } = useAuth0();
  const [currentPage, setCurrentPage] = useState(1);

  const { permissionsError, main, pageDataLoading, mainError } = usePageQueries(
    { isAuthenticated }
  );

  const isError = mainError || permissionsError;

  if (pageDataLoading) return <CircularProgress />;
  if (isError) return <div>Sorry an Error occurred</div>;

  console.log(main);

  return (
    <>
      <Pagination
        current={currentPage}
        onChange={(p) => {
          setCurrentPage(p);
        }}
        total={main.length}
      />
      {main &&
        main
          .filter(
            (news, index) =>
              index >= (currentPage - 1) * 10 && index < currentPage * 10
          )
          .map((news, index) => {
            return <NewsCard news={news} key={`news_${index}`}></NewsCard>;
          })}
      <Pagination
        current={currentPage}
        onChange={(p) => {
          setCurrentPage(p);
        }}
        total={main.length}
      />
    </>
  );
};

export default News;
